export const fillShortTextInputValue = ({ drawerData, index, values, readOnly }) => {
    if (drawerData.length > 0 && drawerData[index]) {
      drawerData[index].state = {
        ...drawerData[index].state,
        shortTextValue: values.shortTextValue,
        mainShortTextInputValue: values.shortTextInputValue,
        subShortTextValue: values.subShortTextValue,
        readOnly
      };
    }
  };
  